module.exports = __webpack_public_path__ + "img/V47.582f1349.jpg";